export namespace SignupErrorConstants {
  export const EMAIL_ALREADY_IN_USE: RegExp = /email \[.*\] is already in use/;
  export const USER_ALREADY_EXISTS: RegExp = /User already exists for Person with id=/;
  export const WEAK_PASSWORD: RegExp = /The password is too weak/;
  export const RIDER_NOT_FOUND: RegExp = /Rider with id=\[.*\] not found/;
  export const FAILED_PROOFING: RegExp = /Rider eligibility proofing failed/;
  export const RIDER_APP_NOT_AVAILABLE_FOR_ORGANIZATION: RegExp = /Rider app is not enabled for any matching organizations/;
  export const RIDER_PREVIOUSLY_REGISTERED: RegExp = /Rider with id=\[.*\] has been previously registered/;
  export const RIDER_COMPLETED_VERIFICATION: RegExp = /Rider with emailAddress=\[.*\] has already completed email verification/;
}
